import { useState } from 'react';
import { orgApi, apiErrorMessage } from '../services/api';
import { logout } from '../services/auth';
import { Button, Card, Field } from './ui';
import logo from '../assets/icon.png';

export default function CreateOrgScreen({ onCreated }) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleCreate = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await orgApi.createOrganization({ name: name.trim(), type: 'institute' });
      onCreated();
    } catch (err) {
      setError(apiErrorMessage(err, 'Failed to create the organization'));
      setBusy(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <div className="login-shell">
      <Card className="login-card">
        <div className="brand login-brand">
          <img src={logo} alt="PrepGen logo" className="brand-logo" />
          <span>Prepgen.ai<small>for Institutes</small></span>
        </div>
        <h1>Create your institute</h1>
        <p className="muted">Your account doesn't own an institute organization yet. Create one to get started.</p>
        <form className="form" onSubmit={handleCreate}>
          <Field label="Institute name">
            <input placeholder="e.g. Apex Coaching" value={name} onChange={(e) => setName(e.target.value)} />
          </Field>
          {error && <p className="login-error">{error}</p>}
          <Button type="submit" disabled={busy || !name.trim()}>
            {busy ? 'Creating…' : 'Create institute'}
          </Button>
          <Button variant="text" type="button" onClick={handleLogout}>Sign in with a different account</Button>
        </form>
      </Card>
    </div>
  );
}
